import PromoCodeActions from '../../../actions/PromoCodeActions';

export const actions = {
    getDataLink(id, success) {
        const params = {
            ids: id
        };

        PromoCodeActions.getListLinks(params, (response) => {
            if(response.items) {
                success && success(response.items[0]);
            } else {
                success && success(response[0]);
            }
        }, {});
    },

    savePromoCode(params, success) {
        PromoCodeActions.savePromoCode(params, (response) => {
            success && success(response.items[0]);
        }, {});
    },

    validatePromoCode(params, success) {
        PromoCodeActions.validatePromoCode(params, (response) => {
            success && success(response.items[0]);
        }, {});
    },

    editPromoCode(params, success) {
        PromoCodeActions.editPromoCode(params, (response) => {
            success && success(response.items[0]);
        }, {});
    }
};
